
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const LandingPage = () => {
  const { googleLogin, isAuthenticated, loading } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isAuthenticated) {
      const postLoginRedirect = sessionStorage.getItem('post_login_redirect');
      if (postLoginRedirect) {
        sessionStorage.removeItem('post_login_redirect');
      }
      navigate(postLoginRedirect || '/translator/dashboard', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center text-gray-800">
      <div className="text-center p-10">
        <h1 className="text-5xl font-bold mb-4">{t('landingPage.title')}</h1>
        <p className="text-xl mb-8">{t('landingPage.subtitle')}</p>
        <button
          onClick={googleLogin}
          className="bg-blue-500 text-white font-bold py-3 px-8 rounded-full hover:bg-blue-600 transition duration-300 flex items-center gap-2 mx-auto"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          {t('landingPage.signInWithGoogle')}
        </button>
      </div>

      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-2">{t('landingPage.certification.title')}</h3>
            <p>{t('landingPage.certification.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-2">{t('landingPage.aiWorkflow.title')}</h3>
            <p>{t('landingPage.aiWorkflow.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-2">{t('landingPage.documentSupport.title')}</h3>
            <p>{t('landingPage.documentSupport.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-2">{t('landingPage.legalSafeguards.title')}</h3>
            <p>{t('landingPage.legalSafeguards.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-2">{t('landingPage.delivery.title')}</h3>
            <p>{t('landingPage.delivery.description')}</p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-bold mb-2">{t('landingPage.officialRecognition.title')}</h3>
            <p>{t('landingPage.officialRecognition.description')}</p>
          </div>

        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="text-center">
          <h2 className="text-3xl font-bold mb-4">{t('landingPage.trustedPartner.title')}</h2>
          <p className="text-lg text-gray-600 mb-8">
            {t('landingPage.trustedPartner.description')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
